import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { CheckCircle2Icon, ShoppingBagIcon, XIcon } from 'lucide-react';
import { recentPurchases } from '../data/purchases';
const FIRST_DELAY = 8000;
const VISIBLE_FOR = 5000;
const MIN_GAP = 15000;
const MAX_GAP = 30000;
function randomGap() {
  return MIN_GAP + Math.random() * (MAX_GAP - MIN_GAP);
}
export function PurchaseNotifications() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const reduceMotion = useReducedMotion();
  useEffect(() => {
    if (dismissed) return;
    const timer = window.setTimeout(() => {
      if (visible) {
        setVisible(false);
        setIndex(i => (i + 1) % recentPurchases.length);
      } else {
        setVisible(true);
      }
    }, visible ? VISIBLE_FOR : index === 0 ? FIRST_DELAY : randomGap());
    return () => window.clearTimeout(timer);
  }, [visible, index, dismissed]);
  const purchase = recentPurchases[index];
  return <div className="pointer-events-none fixed bottom-4 left-4 right-4 z-50 sm:right-auto" aria-live="polite" data-id="element-42" data-mp="otv4ercy77g7">
      <AnimatePresence data-id="element-43" data-mp="jtyyunolr7yj">
        {visible && !dismissed && <motion.div key={purchase.name} initial={reduceMotion ? {
        opacity: 0
      } : {
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={reduceMotion ? {
        opacity: 0
      } : {
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative flex w-full items-center gap-3 rounded-2xl border border-line bg-white p-3 pr-9 shadow-[0_16px_40px_-16px_rgba(20,83,45,0.45)] sm:w-[340px]" data-id="element-44" data-mp="jurw8y1o8l40">
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-brand-soft" data-id="element-45" data-mp="3n8w1bw4vbgwg">
              <ShoppingBagIcon className="h-6 w-6 text-brand" aria-hidden="true" data-id="element-46" data-mp="3kqsyb3iy33ze" />
            </span>
            <div className="min-w-0" data-id="element-47" data-mp="3ppvrnqpkblrj">
              <p className="truncate text-sm font-bold text-charcoal" data-id="element-48" data-mp="3pouftk0q2v8r">
                {purchase.name} <span className="font-medium text-muted" data-id="element-49" data-mp="3atehh2t40d6k">de {purchase.city}</span>
              </p>
              <p className="truncate text-sm text-charcoal" data-id="element-50" data-mp="3fqwtx36c5ajb">
                compró <span className="font-bold text-brand" data-id="element-51" data-mp="320b8p7tesoi9">{purchase.product}</span>
              </p>
              <p className="mt-0.5 flex items-center gap-1 text-xs text-muted" data-id="element-52" data-mp="31ygojvpyp0f8">
                <CheckCircle2Icon className="h-3.5 w-3.5 text-brand" aria-hidden="true" data-id="element-53" data-mp="36t4cnth1zsta" />
                Compra verificada · {purchase.time}
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Cerrar avisos de compra" className="absolute right-2 top-2 rounded-full p-1 text-muted transition-colors duration-150 ease-out hover:bg-brand-soft hover:text-brand focus:outline-none focus-visible:ring-2 focus-visible:ring-brand" data-id="element-54" data-mp="2x1zvcn3wnvva">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-55" data-mp="24f09nvjagsa2" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}